import { render, staticRenderFns } from "./PropertyAssessmentGrid.vue?vue&type=template&id=33fa2271&"
import script from "./PropertyAssessmentGrid.vue?vue&type=script&lang=js&"
export * from "./PropertyAssessmentGrid.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAssessmentGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports